import React from 'react';
import { Col, Row } from 'reactstrap';
import { FormSelectField } from '../../common/components/formFields';

const getTiresSize = () =>
  Array.from(Array(10), (_, i) => ({ value: i + 1, label: `${i + 1} mm` }));

function VehicleTiresForm() {
  return (
    <>
      <Row>
        <Col>
          <h4 className="my-2">Tyres depth</h4>
        </Col>
      </Row>
      <Row>
        <Col md="4">
          <FormSelectField
            name="nearsideFront"
            label="Nearside Front"
            options={getTiresSize()}
          />
        </Col>
        <Col md="4">
          <FormSelectField
            name="nearsideRear"
            label="Nearside Rear"
            options={getTiresSize()}
          />
        </Col>
      </Row>
      <Row>
        <Col md="4">
          <FormSelectField
            name="offsideFront"
            label="Offside Front"
            options={getTiresSize()}
          />
        </Col>
        <Col md="4">
          <FormSelectField name="offsideRear" label="Offside Rear" options={getTiresSize()} />
        </Col>
      </Row>
    </>
  );
}

VehicleTiresForm.propTypes = {};

export default VehicleTiresForm;
